<template>
  <div>
     <section id="page-title">
        <div class="container clearfix">
          <h1 data-animate="fadeInUp">2018 SPRING</h1>
          <span data-delay="300" data-animate="fadeInUp">Aladdin</span> 
        </div>
      </section>
      <section id="content">
            <div class="content-wrap">
                <div class="container clearfix">
                    <!-- Portfolio Filter
============================================= -->
                    <!-- #portfolio-filter end -->
                    <div class="clear"></div>
                    <!-- Portfolio Items
============================================= -->
                    <div id="portfolio" class="portfolio-masonry clearfix">
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s01.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/01.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s02.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/02.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <!--
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s03.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-springs/03.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article> 
                        -->
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s04.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/04.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s05.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/05.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/correcions03.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/correcion03.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s06.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/06.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s07.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/07.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s09.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/09.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s10.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/10.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s11.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/11.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s12.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/09.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s13.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/13.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s14.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/14.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <!--
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article> 
                        -->
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s16.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/16.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s18.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/18.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/s19.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/19.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/sv01.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/v01.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/correcionsv02.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/correcionv02.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/correcionsv03.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/correcionv03.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/sv04.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/correcionv04.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/correcionsv05.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/v05.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/sv06.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/v06.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/sv07.png" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/v07.png" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/sv08.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/v08.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/sv09.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/v09.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                        <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/sv11.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/v11.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                         <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/sv12.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/v12.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>
                         <article class="portfolio-item 2016-spring">
                            <div class="portfolio-image">
                                <a href="portfolio-single.html"> <img src="/assets/img/2018-spring/thumbs/sv13.jpg" alt="Spring 2016 IDS" /> </a>
                                <div class="portfolio-overlay"> <a href="/assets/img/2018-spring/v13.jpg" data-lightbox="image" class="center-icon"><em class="icon-line-plus"></em></a> </div>
                            </div>
                        </article>

                    </div>
                </div>
            </div>
        </section>
        <!-- #content end -->
  </div>
</template>
<script>
  export default {
    name: "2016Spring",
    components: {
    },
    mounted(){
        jQuery(window).load(function() {

        var $container = jQuery('#portfolio');

        $container.isotope({
            transitionDuration: '0.65s'
        });

        jQuery('#portfolio-filter a').click(function() {
            jQuery('#portfolio-filter li').removeClass('activeFilter');
            jQuery(this).parent('li').addClass('activeFilter');
            var selector = $(this).attr('data-filter');
            $container.isotope({
                filter: selector
            });
            return false;
        });

        $('#portfolio-shuffle').click(function() {
            $container.isotope('updateSortData').isotope({
                sortBy: 'random'
            });
        });

        jQuery(window).resize(function() {
            $container.isotope('layout');
        });

    });
    }
  }
</script>
